import script from "./PatientsListView.vue?vue&type=script&setup=true&lang=js"
export * from "./PatientsListView.vue?vue&type=script&setup=true&lang=js"

import "./PatientsListView.vue?vue&type=style&index=0&id=e3b85656&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e3b85656"]])

export default __exports__